<template>

     <div class="iwd-modal" id="product-detail-modal" :class="{open: is_opened, initialized: is_initialized}">
         <div class="modal-inner">
             <button class="close-modal" @click="closeModal()"></button>
             <div class="nav-col left">
                 <span :class="{disabled: !product_data.images[active_slide_index - 1]}" @click="previousImage()"></span>
             </div>
             <div class="nav-col right">
                 <span :class="{disabled: !product_data.images[active_slide_index + 1]}" @click="nextImage()"></span>
             </div>
             <div class="product-gallery-portal">
                 <ul class="product-gallery-reel" :style="{width: (product_data.images.length * 100) + '%', left: -(active_slide_index * 100) + '%'}">
                     <li class="product-image" v-for="image in product_data.images" :style="{width: (100/(product_data.images.length)) + '%'}">
                         <img :src="image" alt="">
                     </li>
                 </ul>
             </div>
             <section class="product-gallery-text">
                 <h1>{{ product_data.title }}</h1>
                 <div v-html="product_data.description"></div>
             </section>
         </div>
     </div>

</template>

<script>

    import { store } from '../../data_hub';

    export default {
    	data(){
    		return {
                // modal_el: null,
                is_opened: false,
                active_slide_index: 0,
                is_initialized: false,
                product_data: {
                    title: '',
                    description: '',
                    images: []
                }
            }
        },
        methods: {
            initialize(data)
            {
                this.product_data = data;
                this.active_slide_index = 0;

                this.is_opened = true;

                setTimeout(()=>{
                	this.is_initialized = true;
                },400); // same as css transition time on opacity
            },
            closeModal()
            {
                this.is_initialized = false;
                this.is_opened = false;
            },
            nextImage(){
                this.active_slide_index++;
            },
            previousImage()
            {
                this.active_slide_index--;
            }
        },
        mounted() {

    		const self = this;

            $('.store-product figure').click(function()
            {
                const parent        = $(this).parent('form');

                if(parent.data('gallery-disabled')){
                    return false;

                }
                const title         = parent.data('title');
                const img_codes     = $(this).parent('form').data('images');
                const description   = parent.data('description');

                let images = [];

                store.commit('setScreenMode');

                const size_suffix   = store.getters.isDesktopScreen ? '-large.jpg' : '-small.jpg';

                const image_path    = '/build/product-images/';
                for(let i=0; i<img_codes.length; i++){
                    images[i] = image_path + img_codes[i] + size_suffix;
                }

                self.initialize({
                    'title': title,
                    'description': description,
                    'images': images
                });
            });
        }
    }

</script>
